export const GetWithdrawInitial = "/Request/GetWithdrawInitial";

export const WithdrawInitial = "/Request/WithdrawInitial";

export const SendSMSForWithdraw = "/Request/SendSMSForWithdraw";
export const SendEmailForWithdraw = "/Request/SendEmailForWithdraw";

export const WithdrawConfirm = "/Request/WithdrawConfirm";

export const GetWithdrawAmountMax = ({ coinId, typeId }) =>
  `/Request/GetWithdrawAmountMax?CoinId=${coinId}&TypeId=${typeId}`;

export const GetValidateAddressCore = ({ coinId, networkId, address }) =>
  `/Request/GetValidateAddressCore?CoinId=${coinId}&NetworkId=${networkId}&Address=${address}`;
